export default "__VITE_ASSET__e66960ff__"